import type { NDateLocale } from './enUS'
import { uk } from 'date-fns/locale'

const dateUkUA: NDateLocale = {
  name: 'uk-UA',
  locale: uk
}

export default dateUkUA
